export default __webpack_public_path__ + "static/media/download.30a37674.svg";